import { ArrayPath } from './ArrayPath'

const isNegativeZero = (value: any) => Object.is(value, -0)

/**
 * Returns a string path from an ArrayPath
 * @param path the ArrayPath to parse
 * @param format The format of the resulting string path
 * @param bracketed Returns the string path wrapped in double brackets if true
 * @returns The generated string path
 */
export const getStringPath = (
  path: ArrayPath,
  format: 'js' | 'json' | 'jsonata' | 'dot' = 'jsonata',
  bracketed = false
) =>
  ((path) => (bracketed ? `{{${path}}}` : path))(
    format === 'json' || format === 'dot'
      ? path
          .reduce(
            (acc, x, i) => {
              acc.push(
                typeof x === 'string'
                  ? format === 'json'
                    ? x.replace(/\//g, '\\/')
                    : x.replace(/\./g, '\\.')
                  : isNegativeZero(x)
                  ? '-0'
                  : x.toString()
              )
              return acc
            },
            format === 'json' ? ['#'] : []
          )
          .join(format === 'json' ? '/' : '.')
      : path.length
      ? path
          .map((x, i) =>
            typeof x === 'string'
              ? x.match(/^[a-zA-Z_][a-zA-Z_0-9]*$/) &&
                (format !== 'jsonata' ||
                  (x !== 'true' && x !== 'false' && x !== 'null'))
                ? x
                : format === 'js'
                ? `[${JSON.stringify(x)}]`
                : JSON.stringify(x)
              : i === 0 && format === 'jsonata'
              ? `$[${isNegativeZero(x) ? '-0' : x}]`
              : `[${isNegativeZero(x) ? '-0' : x}]`
          )
          .reduce((acc, curr) =>
            curr[0] === '[' ? `${acc}${curr}` : `${acc}.${curr}`
          )
      : format === 'jsonata'
      ? '$'
      : ''
  )
